import React, { Component } from 'react';
import AppHeader from './components/header';
import Main from './main';
import eb from './utils/EventBus';
import { ToastContainer, toast } from 'react-toastify';
import auth from './store/auth';
import axios from 'axios';
import Search from './components/search';
import { Header } from 'semantic-ui-react'

class App extends Component {
  
  componentDidMount() {
    eb.on('toast', this.toast)
  }

  componentWillMount() {
    axios.interceptors.response.use(
      response => response,
      error => {
        const {status} = error.response;
        if (status === 401) {
          toast.error("Not authorized to access the page. Please login", {
            position: toast.POSITION.TOP_RIGHT
          });      
        }
        //this.props.history.push('/login');
        return Promise.reject(error);
     }
    );
    this.setUpAxios();
  }

  componentWillUpdate() {
    this.setUpAxios();
  }

  setUpAxios() {
    if (auth.isUserAuthenticated()) {
      console.log('token setup');
      axios.defaults.headers.common['Authorization'] = `bearer ${auth.getToken()}`;
    } else {
      console.log('token removed');
      delete axios.defaults.headers.common['Authorization'];
    }
  }

  toast = (message) => {
    toast.success(message.text, {
      position: toast.POSITION.TOP_RIGHT
    });
  }

  render() {
    const loggedIn = auth.isUserAuthenticated();

    return (
      <div className={`App ${loggedIn ? 'flex': ''}`}>
        <Header className="app-top-bar">
          {/* <img src={Logo} width={32} height={32} /> */}
          <div className="app-name">Comply. Audit. Store.</div>
          {loggedIn && <Search />}
          <hr className="app-line" />
        </Header>
        {loggedIn && <AppHeader />}
        <ToastContainer />
        <Main />
      </div>
    );
  }
}

export default App;

 //{loggedIn && <Search />} -- Commented on 11-sep-2018 as search funcionality is not needed at this point



// WEBPACK FOOTER //
// ./src/App.js